import { Outlet } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./PublicLayout.css";

const titlePrefix = window.__env.APP_TITLE_PREFIX || "Get Move - ";

/**
 * Layout per le pagine pubbliche (legali) linkate dall'app: niente navbar né
 * sidebar del gestionale, contenuto a tutta pagina.
 */
export default function PublicLayout() {
  return (
    <main className="public-page">
      <Helmet titleTemplate={`${titlePrefix}%s`}></Helmet>
      <Outlet />
    </main>
  );
}
